<div class="basicrow tabtopb f-black roboto-r f-reg" *ngIf="this.screen==4">
        <div class="basicr-line f-big">
            Formulario de Afiliaci&oacute;n
        </div>

        <div class="basicrow text-center">
            <div class="shortcont">
                <div class="basicrow m-top-i">
                    <div class="basicrow text-justify">
                        Ahora Claro te brinda el servicio de D&eacute;bito Directo en el que podr&aacute;s afiliar tu pago de renta mensual para que se ejecute de manera autom&aacute;tica, as&iacute; no tendr&aacute;s que preocuparte por recordar tu fecha de facturaci&oacute;n y que tu servicio sea suspendido.
                    </div>
                </div>

                <div class="basicrow m-top-i m-bott-ii">
                    <div class="basicrow roboto-b f-bmed m-bott-ii">
                        Afiliar a
                    </div>
                    <select (change)="this.cambiarTipoPago()" [(ngModel)]="this.tiposPago" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)">
                        <option *ngFor="let item of this.tiposPagos" [ngValue]="item.value">{{item.label}}</option>
                    </select>
                </div>

                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>

                <div class="basicrow m-top-i">
                    <div class="basicrow roboto-b f-bmed">
                        Datos de la Tarjeta
                    </div>

                    <div class="basicrow">
                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" name="typeCard" id="cardVisa" [(ngModel)]="this.type" value="VS" ng-required="!this.type">
                                </div>
                            </div>

                            <img width="100%" src="../../../assets/images/card-a.png">
                        </div>

                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" name="typeCard" id="cardAmex" [(ngModel)]="this.type" value="AM" ng-required="!this.type">
                                </div>
                            </div>

                            <img width="100%" src="../../../assets/images/card-d.png">
                        </div>

                        <div class="cred-opts">
                            <div class="autocont vcenter">
                                <div class="tabcell">
                                    <input type="radio" name="typeCard" id="cardMaster" [(ngModel)]="this.type" value="MC" ng-required="!this.type">
                                </div>
                            </div>

                            <img width="100%" src="../../assets/images/card-b.png">
                        </div>
                    </div>
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; Nombre y Apellido
                    </label>

                    <input class="inp-f" name="nameOnCard" [(ngModel)]="this.nameOnCard"  maxlength="85" required>
                </div>

                <div class="basicrow m-top-i">
                    <label class="label-f">
                        &#42; N&uacute;mero de Tarjeta
                    </label>

                    <input [appOnlyNumber] type="text" class="inp-f" name="cardNum" [(ngModel)]="this.cardNum" ng-pattern="/^\d+$/" maxlength="19" required numbers-only autocomplete="off">

                </div>

                <div class="basicrow m-bott-ii">
                    <div class="row">
                        <div class="col-xs-12 col-md-6  col-lg-6 m-top-i">
                            <label class="label-f">
                                &#42; Vencimiento de Tarjeta
                            </label>

                            <div class="basicrow">
                                <div class="row">
                                    <div class="col-xs-12 col-md-6  col-lg-6">
                                        <label class="label-r sidenmbr vcenter w-auto">
                                            <span class="tabcell">
                                                    Mes
                                            </span>
                                        </label>
                                        <div class="autorow   mob-wid pull-right wid-debt">
                                            <div >
                                                <select class="sel-f exprdsize" id="card-month" name="card_month" [(ngModel)]="this.selectedMonth" style="background-image:url(/assets/images/selectabarrw.png)">
                                                  <option  *ngFor="let month of this.months"  value="{{month}}">{{month}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-md-6  col-lg-6 h-mtop-iv">
                                        <label class="label-r sidenmbr vcenter w-auto">
                                            <span class="tabcell">
                                                    A&ntilde;o
                                            </span>
                                        </label>
                                        <div class="autorow   mob-wid pull-right wid-debt">
                                            <div >
                                                <select class="sel-f exprdsize" id="card-year" name="card_year" [(ngModel)]="this.selectedYear" style="background-image:url(/assets/images/selectabarrw.png)">
                                                    <option *ngFor="let year of this.years"  value="{{year}}">{{year}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-md-6 col-lg-6 m-top-i w-cod-debit">
                            <label class="label-f">
                                &#42; C&oacute;digo de Seguridad (CVV)
                            </label>

                            <input [appOnlyNumber] type="password" class="inp-f" name="cvNum" [(ngModel)]="this.cvNum" maxlength="4" required numbers-only autocomplete="off">
                        </div>
                    </div>
                </div>

                <div class="basicrow m-top-i">
                    <div class="logline full"></div>
                </div>

                <div class="basicrow text-center m-top-i">
                    <a   class="btns def-i red pull-right vcenter red-full-b" (click)="this.debitCreditCard();">
                        <span class="tabcell">
                            Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </a>


                </div>
            </div>
        </div>
</div>
